import { ReactElement } from 'react';
import { formatDateDDMMYY, isFilterValuePresent } from '@helper/utils';
import { NavLink } from 'react-router-dom';
import { RightTabCount } from '@components/common/count/RightTabCount';
import { LmsUserListFilterObject, useLmsUserListFilterStore } from '@store/lms/userListFilterStore';

interface IUserListFilterTagProps {
	count: number;
}

export const UserListFilterTag = (props: IUserListFilterTagProps): ReactElement => {
	const { count } = props;
	const { lmsUserListFilter, updateFilter, resetFilter } = useLmsUserListFilterStore() as {
		lmsUserListFilter: LmsUserListFilterObject;
		updateFilter: (filter: Partial<LmsUserListFilterObject>) => void;
		resetFilter: () => void;
	};

	const renderFilterValue = (key: string, value: string): string | null => {
		if (key === 'createddate') {
			if (Array.isArray(value) && value.length === 2 && value[0] instanceof Date && value[1] instanceof Date) {
				const sd = value[0];
				const ed = value[1];
				return `${formatDateDDMMYY(sd)} - ${formatDateDDMMYY(ed)}`;
			}
		}
		if (key === 'status') {
			return value || null;
		}
		if (key === 'competition_tag') {
			return value ? 'Competition Contractor' : null;
		}
		if (key === 'rigidGluePotential') {
			return value ? `Glue Consumption >= 50` : null;
		}
		if (key === 'source') {
			return value ? `Lead Submitted by: ${value}` : null;
		}
		return String(value);
	};

	const handleCross = (
		e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
		key: string,
		filterData: LmsUserListFilterObject
	): void => {
		e.preventDefault();
		let defaultValue;

		if (key === 'createddate') {
			defaultValue = [null, null];
		} else if (key === 'status') {
			defaultValue = '';
		} else if (key === 'competition_tag' || key === 'rigidGluePotential') {
			defaultValue = false;
		} else if (key === 'source') {
			defaultValue = '';
		}

		updateFilter({
			...filterData,
			[key]: defaultValue,
		});
	};

	if (!lmsUserListFilter || !Object.values(lmsUserListFilter).some(isFilterValuePresent)) return <></>;

	return (
		<div className="filter-tags">
			<ul className="tag-list">
				{Object.entries(lmsUserListFilter).map(([key, value]) => {
					if (isFilterValuePresent(value) && renderFilterValue(key, value)) {
						return (
							<li key={key}>
								{`${renderFilterValue(key, value)}`}
								<NavLink
									to="#"
									aria-label="disable tag"
									onClick={(e) => {
										handleCross(e, key, lmsUserListFilter);
									}}
								>
									<span className="icon-cross"></span>
								</NavLink>
							</li>
						);
					}
				})}
				{Object.values(lmsUserListFilter).some(isFilterValuePresent) && (
					<NavLink to="#" aria-label="Clear All" className="clear-all-btn" onClick={resetFilter}>
						Clear All
					</NavLink>
				)}
			</ul>
			<RightTabCount count={count} />
		</div>
	);
};
